// extracted by mini-css-extract-plugin
export default {"cost":"SyADs _1brkc"};